<template>
<div class="chapter">
<div class="inner_page">
<h2 class="sec_front">List of maps</h2>
<p class="order_list"><span class="order_hang">1.</span> The threat to Europe from the Ottoman Empire.</p>
<p class="order_list"><span class="order_hang">2.</span> The Sykes-Picot Agreement of 1916.</p>
<p class="order_list"><span class="order_hang">3.</span> Islamic State territory in June 2014.</p>
<p class="order_list"><span class="order_hang">4.</span> A possible Kurdistan.</p>
<p class="order_list"><span class="order_hang">5.</span> The once and future caliphate.</p>
<p class="order_list"><span class="order_hang">6.</span> The Baltic states and their big near neighbour.</p>
<p class="order_list"><span class="order_hang">7.</span> Disputes in the South China Sea.</p>
<p class="order_list"><span class="order_hang">8.</span> US bases and military facilities around the world.</p>
<p class="pbrk"> </p>
<div class="img_container">
<img alt="Image" src="images/map_1.jpg"/>
<p class="capl">The threat to Europe from the Ottoman Empire.</p>
</div>
<div class="img_container">
<img alt="Image" src="images/map_2.jpg"/>
<p class="capl">The Sykes-Picot Agreement of 1916.</p>
</div>
<div class="img_container">
<img alt="Image" src="images/map_3.jpg"/>
<p class="capl">Islamic State territory in June 2014.</p>
</div>
<div class="img_container">
<img alt="Image" src="images/map_4.jpg"/>
<p class="capl">A possible Kurdistan.</p>
</div>
<div class="img_container">
<img alt="Image" src="images/map_5.jpg"/>
<p class="capl">The once and future caliphate.</p>
</div>
<div class="img_container">
<img alt="Image" src="images/map_6.jpg"/>
<p class="capl">The Baltic states and their big near neighbour.</p>
</div>
<div class="img_container">
<img alt="Image" src="images/map_7.jpg"/>
<p class="capl">Disputes in the South China Sea.</p>
</div>
<div class="img_container">
<img alt="Image" src="images/map_8.jpg"/>
<p class="capl">US bases and military facilities around the world.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 06_Maps.vue?814211d2